<template>
  <div class="d-flex">

    <MarkerInfoModal
      :events="markerInfoModalEvents"
      :task="markerInfoModalTask"
      :showing="!!markerInfoModalTaskId"
      @close="hideMarkerInfoModal"
      @deviationApproved="$emit('deviationApproved')"
    />

    <!-- tracker list -->
    <div class="tracker-list">
      <v-menu
        bottom
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             style="margin: 4px 4px 8px 4px"
             v-bind="attrs"
             v-on="on"
             :class="{ 'filter-menu-active' :
             Object.keys(showItemInCalendar).find(key => showItemInCalendar[key] === false)}"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>

        <div class="switch-menu">
          <div v-for="task in tasks" :key="task.uuid" class="switch-line">
            <div class="mr-6">{{ task.name }}</div>
            <v-switch
              color="blue"
              class="mt-0"
              style="height: 30px;"
              v-model="showItemInCalendar[task.uuid]"
            ></v-switch>
          </div>
        </div>
      </v-menu>

      <v-btn
        v-for="task in tasks"
        :key="task.id"
        class="tracker-list-item"
        @click="editTask(task.uuid)"
      >
        {{ task.name }}
      </v-btn>

      <!-- Static "add item" tracker -->
      <v-btn
        class="tracker-list-item-add text-decoration-none"
        @click="$router
        .push({ name: 'member-show-add-task', params: { userId: $route.params.userId } })"
      >
        <div class="d-flex flex-column">
          <v-icon color="#5D79B9" size="34">mdi-plus-circle-outline</v-icon>
          <div class="tracker-list-item-text">{{ $t('Add new task') }}</div>
        </div>
      </v-btn>

    </div>

    <div
      v-if="filteredTasks.length"
      class="calendar-wrapper">
      <div class="calendar" ref="calendar" v-dragscroll>
        <!-- Times -->
        <div
          :style="`
          margin-left: -${hourWidth/2}px;
          width: ${(times.length - 1) * hourWidth + 200 + (hourWidth / 2)}px;
          `"
          class="time-bar"
        >
          <div
            v-for="(time, index) in timesToShow"
            :key="`time-${index}`"
            class="time-text"
            :style="`
            left: ${index * hourWidth + 200}px;
            width: ${hourWidth}px;
            `"
          >
            {{ time }}
          </div>
        </div>
        <div
          :style="`position: sticky; left:0;`"
        >
          <div
            v-for="(day, index) in filteredTasks"
            :key="`day-${index}`"
            :style="`
            position: absolute;
            top: ${(daysToRender.length - 1 - index) * (50 * day.tasks.length)}px;
            width: 100%;
            `"
            class="floating-info-container"
          >
            <!-- task names -->
            <div
              v-for="(task, taskIndex) in day.tasks"
              :key="`day-${index}-task-${taskIndex}`"
              class="task-indicator"
              :style="`top: ${taskIndex * 50}px;`"
            >
              {{ task.name }}
            </div>

            <!-- Date -->
            <div
              class="date-indicator"
            >
              {{ dateToFullDateTime(day.date) }}
            </div>

          </div>
        </div>
        <svg
          :width="200 + 24 * hourWidth"
          :height="daysToRender[0].tasks.length * 50 * daysToRender.length + 20"
          :viewBox="`0 0 ${200 + 24 * hourWidth}
          ${daysToRender[0].tasks.length * 50 * daysToRender.length + 20}
          `"
        >
          <!-- Loop through days to render -->
          <g>
            <!-- The reason order is so odd, is that the elements are rendered from the bottom -->
            <!-- This is so that above elements timestamps etc. can be rendered on top-->
            <week-calendar-single-day
              v-for="(day, index) in filteredTasks"
              :key="index"
              :tasks="day.tasks"
              :date="day.date"
              :order="daysToRender.length - 1 - index"
              :hour-width="hourWidth"
              :approved-deviations-only="approvedDeviationsOnly"
              :current-time="currentTime"
              :highlightId="highlightId"
              @showMarkerTooltip="showMarkerTooltip"
            ></week-calendar-single-day>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>

import {
  subDays, addDays,
  fromUnixTime, format,
} from 'date-fns';
import WeekCalendarSingleDay from '@/modules/calendar/WeekCalendarSingleDay.vue';
import { getLanguagePackFromBrowser } from '../../globals/helpers/language';
import MarkerInfoModal from './MarkerInfoModal.vue';

export default {
  props: {
    tasks: {
      default: () => [],
      type: Array,
      required: true,
    },
    scaleDown: {
      type: Boolean,
      required: false,
      default: false,
    },
    scaleUp: {
      type: Boolean,
      required: false,
      default: false,
    },
    daysToRender: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    WeekCalendarSingleDay,
    MarkerInfoModal,
  },
  data() {
    return {
      approvedDeviationsOnly: false,
      currentTime: Date.now(),
      hourWidth: 100,
      isMounted: false,
      highlightId: null,
      markerTooltip: {
        show: false,
        text: [],
        x: 0,
        y: 0,
      },
      showItemInCalendar: {},
      times: [
        '',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
        '',
      ],
      markerInfoModalTaskId: null,
      markerInfoModalEventIds: [],
    };
  },
  computed: {
    timesToShow() {
      if (this.hourWidth < 46) {
        return this.times.map((item) => item.split(':')[0]);
      }
      return this.times;
    },
    filteredTasks() {
      return this.daysToRender.map(({ date, tasks }) => ({
        date,
        tasks: tasks.filter((item) => this.showItemInCalendar[item.id]),
      }));
    },
    allDates() {
      const today = Date.now();
      return [
        subDays(today, 5),
        subDays(today, 4),
        subDays(today, 3),
        subDays(today, 2),
        subDays(today, 1),
        fromUnixTime(today / 1000),
        addDays(today, 1),
      ];
    },
    markerInfoModalTask() {
      if (this.markerInfoModalTaskId) {
        return this.tasks.find((task) => task.uuid === this.markerInfoModalTaskId);
      }
      return null;
    },
    markerInfoModalEvents() {
      if (this.markerInfoModalTaskId) {
        const task = this.tasks.find((item) => item.uuid === this.markerInfoModalTaskId);
        return task.events.filter((event) => this.markerInfoModalEventIds.includes(event.id));
      }
      return [];
    },
  },
  created() {
    this.tasks.forEach((task) => {
      this.$set(this.showItemInCalendar, task.uuid, true);
    });
  },
  mounted() {
    // update current time every 30 seconds
    this.currentTimeInterval = setInterval(() => {
      this.currentTime = Date.now();
    }, 30000);
    window.addEventListener('resize', this.resizeListener);
    this.isMounted = true;
    this.$nextTick(() => {
      this.hourWidth = this.getHourWidth();
    });
  },
  beforeDestroy() {
    clearInterval(this.currentTimeInterval);
    window.removeEventListener('resize', this.resizeListener, false);
  },
  watch: {
    scaleUp() {
      this.hourWidth = this.getHourWidth();
    },
    scaleDown() {
      this.hourWidth = this.getHourWidth();
    },
  },
  methods: {
    editTask(id) {
      this.$router.push({ name: 'member-show-edit-task', params: { taskId: id } });
    },
    resizeListener() {
      this.hourWidth = this.getHourWidth();
    },
    getHourWidth() {
      const defaultWidth = 100;
      if (this.isMounted) {
        // This condition is currently never reached after first run
        if (this.scaleUp && (this.$refs.calendar?.clientWidth - 200) > defaultWidth * 24) {
          return (this.$refs.calendar.clientWidth - 200) / 24;
        }

        if (this.scaleDown && (this.$refs.calendar?.clientWidth - 200) < defaultWidth * 24) {
          return (this.$refs.calendar.clientWidth - 200) / 24;
        }
      }
      return defaultWidth;
    },
    showMarkerTooltip(payload) {
      this.markerInfoModalTaskId = payload.taskId;
      this.markerInfoModalEventIds = payload.eventIds;
    },
    hideMarkerInfoModal() {
      this.markerInfoModalTaskId = null;
    },
    goToDeviation(id) {
      this.highlightId = id;
    },
    dateToFullDateTime(date) {
      return format(date, 'EEEE do LLL', { locale: getLanguagePackFromBrowser() });
    },
  },
};
</script>

<style scoped lang="scss">
  .calendar-wrapper {
    flex: 1;
    max-width: calc(100vw - 300px - 120px);
    max-height: 100%;
    overflow: auto;
  }

  .calendar {
    overflow: auto;
    max-height: 100%;
    cursor: grab;
  }

  .calendar:active {
    cursor: grabbing;
  }

  .marker-tooltip {
    position: absolute;
    background-color: #fff;
    border-radius: 8px;
    pointer-events: none;
    -webkit-box-shadow: 2px 2px 8px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 2px 2px 8px -2px rgba(0,0,0,0.75);
    box-shadow: 2px 2px 8px -2px rgba(0,0,0,0.75);
    background-color: #f9f9f9;
    z-index: 1000;
    max-width: 400px;

    &-title {
      border-radius: 8px 8px 0px 0px;
      border-bottom: 1px solid #707070;
      padding: 6px;
      font-weight: 600;
      background-color: #fff;
      color: #363636;
    }

    &-item {
      display: flex;
      justify-content: space-between;
    }

    &-item:not(:last-child) .marker-tooltip-notes-box {
      border-bottom: 1px solid #707070;
    }

    &-time {
      padding: 6px;
    }

    &-notes-box {
      background-color: #fff;
      color: $primaryDark;
      padding: 6px;
      font-size: 14px;
      flex: 1;
      border-left: 1px solid #eee;
    }

    &-notes-item {
      margin-bottom: 6px;
      font-size: 11px;

      &-name {
        color: $primary;
        font-weight: 600;
      }

      &-text {
        color: #363636;
      }
    }

    &-time-error {
      color: red;
    }
  }

  .tracker-list {
    display: flex;
    flex-direction: column;
    width: 120px;
    max-height: 100%;
    overflow: auto;
  }

  .tracker-separator {
    height: 1px;
    border: none;
    background-color: $lightGrey;
    margin: 16px 0;
  }

  .tracker-list-item, .tracker-list-item-add {
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;
    margin: 4px;
    border: 1px solid #eee;
    border-radius: 0 4px 4px 0;
    padding: 0px 12px !important;
    white-space: normal;

    &:hover, &-add:hover {
      background-color: rgba(132, 100, 255, 0.1);
    }
  }

  .tracker-list-item-text {
    font-weight: 500;
    padding: 4px;
    color: $primaryDark;
    white-space: normal !important;
  }

  .date-indicator {
    font-weight: bold;
    color: #aaa;
    font-size: 16px;
    position: absolute;
    right: 50%;
    padding-right: -50%;
    top: 0px;
    height: 50px;
    display: flex;
    align-items: center;
    pointer-events: none;
    transform: translateX(50%);
  }

  .task-indicator {
    font-weight: bold;
    color: #505050;
    font-size: 16px;
    white-space: nowrap;
    height: 50px;
    display: flex;
    align-items: center;
    left: 20px;
    position: absolute;
    pointer-events: none;
  }

  .time-bar {
    position: sticky;
    top: 0px;
    text-align: center;
    height: 26px;
    z-index: 100;
    overflow: hidden;
    background-color: #fff;
    border-bottom: 1px solid #eee;
  }

  .time-text {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 26px;
  }

  .switch-menu {
    background-color: #fff;
    padding: 24px;
  }

  .switch-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    align-items: center;
  }

  .switch-menu .switch-line:last-child {
    margin-bottom: 0;
  }

  .filter-menu-active {
    color: #fff;
    background-color: $primary !important;
  }

  .floating-info-container {
    display: flex;
    flex-direction: row;
  }
</style>
